// extracted by mini-css-extract-plugin
module.exports = {"Composition":"Composition_Composition__33Jtt"};